import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {


  os;

  constructor() {

    this.os = this.getMobileOperatingSystem();




  }


  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent;

    if (userAgent.toUpperCase().indexOf('ANDROID') > 0) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710

    if (userAgent.toUpperCase().indexOf('IPAD') > 0 || userAgent.toUpperCase().indexOf('IPHONE') > 0 || userAgent.toUpperCase().indexOf('IPOD') > 0) {
      return "iOS";
    }

    return "unknown";

  }

}
